import styled from "styled-components";
import { Trans } from "@coworker/locales";
import AvatarImage from "../../AvatarImage";
import { UserOrGroupName } from "../../../core/components/UserOrGroupName";
import {
  DetailSection,
  DetailSectionRight,
  DetailSectionLeft,
  SectionText,
  SectionTitle,
} from "./_common";
import { CompactIconWrapper } from "./description";
import Group from "../../../assets/svg/profile-group.svg?react";
import AssignIcon from "../../../assets/svg/icon-profile-cropped.svg?react";
import { useAllStoreUsers } from "@coworker/apprestructured/src/shared/hooks/users/useAllStoreUsers";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

const GroupAvatar = styled(Group)`
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 20px;
`;

function Assignment({ task, title, conf: { icon = null } }) {
  const { data: allStoreUsers, isLoading } = useAllStoreUsers();
  if (isLoading) {
    return (
      <DetailSection>
        <FixaSkeleton width="100%" height="40px" />
      </DetailSection>
    );
  }

  const assignedUser = allStoreUsers?.find(
    (user) =>
      user.fixaUid === task.assigned_user_id ||
      user.uid === task.assigned_user_id
  );
  return (
    <DetailSection>
      {icon && (
        <CompactIconWrapper>
          <AssignIcon />
        </CompactIconWrapper>
      )}
      <DetailSectionLeft>
        <SectionTitle>{title || <Trans>assigned2String</Trans>}</SectionTitle>
        <SectionText data-testid="taskAssignee">
          <UserOrGroupName
            uid={task.assigned_user_id}
            gid={task.assigned_team_id}
          />
        </SectionText>
      </DetailSectionLeft>
      <DetailSectionRight>
        {assignedUser?.uid ? (
          <AvatarImage uid={assignedUser.uid} />
        ) : (
          <GroupAvatar />
        )}
      </DetailSectionRight>
    </DetailSection>
  );
}

export default Assignment;
